<template>
    <div>
        <div class="flex align-items-center py-3">
            <!-- TODO: add slot here to make filters extendable -->
            <div class="mr-2" v-if="state.columns.length">
                <button v-b-modal.editColumnsModal type="button" class="btn btn-secondary d-flex align-items-center">
                    <i class="fa fa-columns mr-1"></i>Columns
                    <span class="badge badge-dark text-white ml-1">
                        {{ selectedColumns.length }} of {{ state.columns.length }}
                    </span>
                </button>
            </div>
        </div>

        <boo-grid
            v-if="state.columns.length && state.rows"
            type="bordered"
            :class="{'table-responsive': state.responsive}"
            :columns="state.columns"
            :rows="state.rows"
            :selectable="state.selectable"
            :allDisplayItemsSelected="allSelected"
            @onItemCheckChange="onItemCheckChange"
            @sortBy="sortBy"
            @cellClick="cellClick"
            @rowClick="rowClick">
        </boo-grid>

        <boo-pagination
            v-if="state.rows.length"
            :storePath="paginationPath"
            @pageChanged="pageChanged">
        </boo-pagination>

        <edit-columns
            v-if="state.columns.length"
            :fields="state.columns"
            @onEdit="onEditColumns">
        </edit-columns>
    </div>
</template>

<script>
    /** Extended grid is a combination of grid, pagination and control buttons */
    import getters from '../../utils/getters';
    import editColumns from './edit-columns.vue';

    const EVENTS = {
        /**
        This event signals that even that changes rows was triggered.
        It is expected that parent will collect details from store and react.
        */
        ROWS_CHANGE: 'rowsChange',
        // One of clickable table cell was clicked.
        CELL_CLICK: 'cellClick',
        ROW_CLICK: 'rowClick',
    };

    export default {
        name: 'extended-grid',
        props: {
            storePath: {type: String, required: true},
        },
        destroyed,
        computed: {
            state() {
                return getters.getValueByPropertyName(this.$store.state, this.storePath, '/');
            },
            paginationPath() {
                return this.storePath + '/pagination';
            },
            checkTrackerPath() {
                return this.storePath + '/checkTracker';
            },
            allSelected() {
                return this.state.checkTracker.allSelected;
            },
            selectedColumns() {
                return this.state.columns.filter(column => column.selected);
            }
        },
        methods: {
            sortBy,
            pageChanged,
            onItemCheckChange,
            onEditColumns,
            toggleSelectAll,
            cellClick,
            rowClick,
        },
        components: {
            'edit-columns': editColumns,
        }
    };

    function destroyed() {
        this.$store.commit(`${this.checkTrackerPath}/restoreDefaults`);
    }

    function sortBy(column, ascending, descending) {
        this.$store.commit(`${this.storePath}/setColumnAttr`, [column.key, 'ascending', ascending]);
        this.$store.commit(`${this.storePath}/setColumnAttr`, [column.key, 'descending', descending]);
        this.$emit(EVENTS.ROWS_CHANGE);
    }

    function pageChanged(paginationState) {
        this.$emit(EVENTS.ROWS_CHANGE, paginationState);
    }

    // TODO: rewrite this code to avoid such strange 'onItemCheckChange' and 'toggleSelectAll' functions.
    function onItemCheckChange(response) {
        if (Array.isArray(response.data)) {
            this.toggleSelectAll(response.checked);
        } else {
            this.$store.commit(`${this.checkTrackerPath}/itemCheckChange`, response.data);
        }
        this.$emit('onItemCheckChange', response);
    }

    function toggleSelectAll(allSelected) {
        if (allSelected) {
            this.$store.commit(`${this.checkTrackerPath}/selectAll`);
        } else {
            this.$store.commit(`${this.checkTrackerPath}/clearAll`);
        }
    }

    // This is bad implementation of child component. It should not edit inputed value.
    function onEditColumns(columns) {
        columns.forEach(column => {
            this.$store.commit(`${this.storePath}/setColumns`, columns);
        })
    }

    function cellClick(cell, row, column) {
        this.$emit(EVENTS.CELL_CLICK, cell, row, column);
    }

    function rowClick(row) {
        this.$emit(EVENTS.ROW_CLICK, row);
    }

</script>



